import type { InitialGeoContext, InitialGeoLocation } from "./initialGeo";
import {
    fetchApproximateLocation,
    ipLocationQueryOptions,
} from "../location-estimate";
import { readSelectedLocation } from "../selected-location";

export async function resolveRouteApproximateLocation(
    context: InitialGeoContext,
    fetchLocation = fetchApproximateLocation,
): Promise<InitialGeoLocation | null> {
    const selectedLocation = readSelectedLocation();
    if (selectedLocation) return selectedLocation;
    if (context.initialGeo) return context.initialGeo;
    if (typeof window === "undefined") return null;

    try {
        const location = await context.queryClient.ensureQueryData({
            ...ipLocationQueryOptions(),
            queryFn: fetchLocation,
        });
        return { lat: location.lat, lng: location.lon };
    } catch {
        return null;
    }
}
